module.exports = __webpack_public_path__ + "img/ic_stepper_large-down.fa0c4ca0.svg";